import type { XangleUIColorType, XangleUIOpacity } from '../types/xangle-vue-ui.types'

export const parseDomSizeValue = (size: number | string, unit = 'px') => {
  const parsedNumber = Number(size)
  if (typeof size === 'string' && Number.isNaN(parsedNumber)) {
    return size
  } else {
    return `${size}${unit}`
  }
}

export const parseToRgbaColor = (
  color: XangleUIColorType,
  opacity: XangleUIOpacity,
) => `rgba(var(--bc-${color}), var(--${opacity}))`
